import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { images } from "../assets";

import { DialogContextType } from "../../DialogComponents/FullScreenDialog";

export const useContext = (): DialogContextType => {
  const { t } = useTranslation("dialogs");

  return useMemo(
    () => ({
      title: {
        text: t("groundInfo.localityInfo"),
        icon: "tools_buffer",
      },
      applyText: t("groundInfo.build"),
      help: {
        openAtFirst: true,
        hintsBlock: {
          title: t("groundInfo.hintBlockTitle"),
          hints: [
            {
              label: t("groundInfo.sourceLayerFeatures"),
              img: images.initialObject,
            },
            {
              icon: "plus",
            },
            {
              label: t("groundInfo.infoFeatures"),
              img: images.objectsContainsInfo,
            },
            {
              icon: "arrow_forward",
            },
            {
              label: t("groundInfo.featuresIntersection"),
              img: images.objectsIntersection,
            },
            {
              icon: "equals",
            },
            {
              label: t("groundInfo.sourceLayerInfoFeatures"),
              img: images.result,
            },
          ],
        },
      },
    }),
    [t],
  );
};
